<template>
  <company009 />
</template>

<script>
import company009 from '@/pages/company/p_company009.vue';

export default {
  components: {
    company009
  }
};
</script>
